/**!
 * Created by Leonardo Cheslacki on 04/03/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import HelpersController from './../helpers/HelpersController';

import WithType from './../helpers/WithType';

let _this = {};

/**
 *
 */
class HelpersStyle extends HelpersController {

    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);
        this.props = props;
        this.main = main;

        this.state = {
            text: ''
        };

        _this = this;
    };

    setStyle = (object, type = '.') => {
        if (this.isObjectIf(object)) {
            let styles = '';

            for (let property in object) {
                styles += `${type}${this.toSlug(property)}{`;

                let fields = this.verifyField(object, property);

                if (this.isObjectIf(fields)) {

                    for (let field in fields) {
                        let value = this.verifyField(fields, field);

                        value && (styles += `${this.toSlug(field)}:${value};`);
                    }
                }
                styles += '}';
            }

            this.state.text = styles;
        }
    };

    /**
     *
     * @param name
     * @param callback
     */
    find = (name, callback) => {
        const {document} = this.props;

        if (!this.isEmpty(name)) {
            name = this.toSlug(name);
            Array.from(document.styleSheets).forEach((styleSheet) => {
                let ownerNode = styleSheet.ownerNode;
                if (ownerNode.localName === 'style' && styleSheet.cssRules) {
                    let dataMeta = ownerNode.attributes.getNamedItem('data-meta');
                    (!!dataMeta && (dataMeta.value === name) && (typeof (callback) === 'function')) && callback(ownerNode);
                }
            });
        }
    }

    /**
     *
     * @param name
     */
    remove = (name) => {
        const {document} = this.props;

        if (!this.isEmpty(name)) {
            this.find(name, (ownerNode) => {
                document.head.removeChild(ownerNode);
            });
        }
    };

    /**
     *
     * @param name
     */
    create = (name) => {
        const {document} = this.props;

        if (!this.isEmpty(name)) {
            this.remove(name);
            let
                style = document.createElement('STYLE'),
                attributeDataMeta = document.createAttribute('data-meta');

            attributeDataMeta.value = this.toSlug(name);
            style.setAttributeNode(attributeDataMeta);
            style.type = 'text/css';
            style.appendChild(document.createTextNode(this.state.text));
            document.head.appendChild(style);
        }
    };
}

HelpersStyle.propTypes = {
    document: PropTypes.object
};


HelpersStyle.defaultProps = {
    document: {}
};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(HelpersStyle, {className: 'HelpersStyle'});
